import { supabase } from './supabase';

// Signed liability forms live in the private `liability-forms` bucket
// (created by the migration); only the logged-in owner can touch them.

const BUCKET = 'liability-forms';

export async function uploadLiabilityForm(clientId: string, file: File): Promise<string> {
  const safeName = file.name.replace(/[^\w.-]+/g, '_').slice(-80) || 'liability-form.pdf';
  const path = `${clientId}/${Date.now()}-${safeName}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    contentType: file.type || 'application/pdf',
  });
  if (error) throw error;
  return path;
}

// Short-lived private link for viewing/downloading the form.
export async function liabilityFormUrl(path: string): Promise<string> {
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, 60 * 10);
  if (error || !data?.signedUrl) throw error ?? new Error('Could not create a link.');
  return data.signedUrl;
}

export async function deleteLiabilityForm(path: string): Promise<void> {
  const { error } = await supabase.storage.from(BUCKET).remove([path]);
  if (error) throw error;
}
